import { ClickEvent } from "@mcleod/components";
import { AutogenLayoutDatafusionBillingOutboundErrors } from "./autogen/AutogenLayoutDatafusionBillingOutboundErrors";
import { Navigation, UrlUtil } from "@mcleod/core";

export class DatafusionBillingOutboundErrors extends AutogenLayoutDatafusionBillingOutboundErrors {
    labelOnClick(event: ClickEvent) {
        const count = this.mainDataSource.activeRow.get("total");
        const urlParams: string[] = [];
        urlParams.push("outboundErrorSearch=true");
        if (count > 0) {
            Navigation.navigateTo("lme/datafusion/InvoiceHistoryList" + UrlUtil.buildQueryString(urlParams), { newTab: false });
        }
    }
}